export default "__VITE_ASSET__d3bdce56__"